import { FC, useEffect, useState } from 'react';
import { Button, Grid, Input, Text } from '@mantine/core';
import tableService from 'services/tableService';
import { useMediaQuery } from '@mantine/hooks';

interface AuthBarProps {
    booking: string;
    setAuth: (email: string, code: string) => void;
    setBooking: (location: string) => void;
}

const AuthBar: FC<AuthBarProps> = (props: AuthBarProps) => {
    const [msg, setMsg] = useState('');
    const [error, setError] = useState('');
    const [email, setEmail] = useState('');
    const [code, setCode] = useState('');
    const isMobile = useMediaQuery('(max-width: 767px)');

    useEffect(() => {
        if (props.booking === '-') {
            setMsg('Et ole vielä varannut pöytää');
        } else if (props.booking) {
            setMsg('Varauksesi on ' + props.booking);
        }
    }, [props.booking]);

    const handleChangeEmail = (event: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(event.target.value);
        props.setAuth(email, code);
    };

    const handleChangeCode = (event: React.ChangeEvent<HTMLInputElement>) => {
        setCode(event.target.value);
        props.setAuth(email, code);
    };

    const onClickButton = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();

        if (email === '' || code === '') {
            setError('Sähköposti ja koodi on pakollisia tietoja');
            return;
        }

        tableService.myBooking(email, code).then(res => {
            if (res.data) {
                if (res.data === '-') {
                    setMsg('Et ole vielä varannut pöytää');
                } else {
                    setMsg('Varauksesi on ' + res.data);
                }
            } else {
                setError('Virheellinen sähköposti tai koodi');
            }

            props.setBooking(res.data);
        });
    };

    return (
        <>
            {!isMobile && (
                <Grid style={{ marginTop: 10, marginBottom: 10 }}>
                    <Grid.Col span={3}>
                        <Input
                            placeholder="Sähköposti"
                            id="email"
                            value={email}
                            onChange={handleChangeEmail}
                            onBlur={handleChangeEmail}
                            style={{ maxHeight: 40 }}
                        />
                    </Grid.Col>
                    <Grid.Col span={3}>
                        <Input
                            placeholder="Koodi"
                            id="code"
                            value={code}
                            onChange={handleChangeCode}
                            onBlur={handleChangeCode}
                            style={{ maxHeight: 40 }}
                        />
                    </Grid.Col>
                    <Grid.Col span={2}>
                        <Button variant="filled" color="violet.1" onClick={onClickButton}>
                            Tarkista
                        </Button>
                    </Grid.Col>
                    <Grid.Col span={4}>
                        {msg ? <Text style={{ color: '#6478df' }}>{msg}</Text> : null}
                        {error ? <Text style={{ color: '#aa2211' }}>{error}</Text> : null}
                    </Grid.Col>
                </Grid>
            )}
            {isMobile && (
                <Grid style={{ marginTop: 10, marginBottom: 10 }}>
                    <Grid.Col span={12}>
                        <Input
                            placeholder="Sähköposti"
                            id="email"
                            value={email}
                            onChange={handleChangeEmail}
                            onBlur={handleChangeEmail}
                            style={{ maxHeight: 40, width: '100%' }}
                        />
                    </Grid.Col>
                    <Grid.Col span={12}>
                        <Input
                            placeholder="Koodi"
                            id="code"
                            value={code}
                            onChange={handleChangeCode}
                            onBlur={handleChangeCode}
                            style={{ maxHeight: 40, width: '100%' }}
                        />
                    </Grid.Col>
                    <Grid.Col span={6}>
                        <Button variant="filled" color="violet.1" onClick={onClickButton}>
                            Tarkista
                        </Button>
                    </Grid.Col>
                    <Grid.Col span={6}>
                        {msg ? <Text style={{ color: '#6478df' }}>{msg}</Text> : null}
                        {error ? <Text style={{ color: '#aa2211' }}>{error}</Text> : null}
                    </Grid.Col>
                </Grid>
            )}
        </>
    );
};

export default AuthBar;
